import TextInput from 'src/design/components/textInput/TextInput';
import withError from 'src/design/components/textInput/withError';

const TextInputWithError = withError(TextInput);

TextInputWithError.validation = TextInput.validation;

export default TextInputWithError;
